import { RangoSalarialPerfil } from '../models/rango-salarial-perfil.interface';

export interface RangoSalarialPerfilState {
  rangosSalariales: RangoSalarialPerfil[];
  selectedRangoSalarial: RangoSalarialPerfil | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
}

export const initialRangoSalarialPerfilState: RangoSalarialPerfilState = {
  rangosSalariales: [],
  selectedRangoSalarial: null,
  loading: false,
  error: null,
  creating: false,
  updating: false
};
